import { NavLink } from 'react-router-dom';
import { formatDate, formatTime } from '@/utils/dateUtils.ts';
import { Call } from '../types.ts';
import { popupToast, sendEvent } from '@/api/nativeBridge.ts';
import { memo } from 'react';

function getCallerName(callItem: Call): string | undefined {
  return process.env.NODE_ENV === 'development' ? '개발테스트' : callItem.name;
}

const DiscoverCallLog = memo(
  ({ callItem, mainIndex }: { callItem: Call; mainIndex: number }) => {
    console.log('SEARCH B DISCOVER CALLLOG :::', callItem);

    function onClickDiscoverSummary(callItem: Call) {
      console.log('onClickEvent');
      if (callItem.isValidCall) {
        sendEvent('SEND_LOG', {
          type: 'GA4',
          key: mainIndex === 0 ? 'AI검색_최근대화' : 'AI검색_지난대화',
          message: '통화이력 더보기',
        });
        sendEvent('GO_DISCOVER_SUMMARY', { callId: callItem.callId });
      } else {
        popupToast(1, '삭제된 통화이력 입니다.');
      }
    }

    function onTouchEndDiscoverSummar(e: React.TouchEvent, callItem: Call) {
      console.log('touchEvent');
      e.preventDefault();
      onClickDiscoverSummary(callItem);
    }

    return (
      <div className="coll-log-section">
        <div className="coll-log-section__contents">
          <p className="info">
            <span className="date">
              {callItem?.callStartTime
                ? formatDate(callItem.callStartTime)
                : ''}
            </span>
            <span className="time">
              {callItem?.callStartTime
                ? formatTime(callItem.callStartTime)
                : '-'}
            </span>
          </p>
          <p className="title">
            <em className="name">
              <span
                onClick={() => onClickDiscoverSummary(callItem)}
                onTouchEnd={(e: React.TouchEvent) =>
                  onTouchEndDiscoverSummar(e, callItem)
                }
              >
                {getCallerName(callItem)}
              </span>
            </em>
            님과의 통화에서 발견했어요
          </p>
          <div className="tag-box">
            {callItem?.searchResult?.map((searchItem, index) => (
              <span
                className="tag-box__item"
                key={`${searchItem.youtube.contents[0]?.videoId}_${index}`}
              >
                #{searchItem.youtube.query}
              </span>
            ))}
          </div>
          <NavLink
            to="#"
            className="more-view"
            onClick={() => {
              onClickDiscoverSummary(callItem);
            }}
            onTouchEnd={(e: React.TouchEvent) =>
              onTouchEndDiscoverSummar(e, callItem)
            }
          >
            통화이력 더보기
          </NavLink>
        </div>
      </div>
    );
  },
);

export default DiscoverCallLog;
